import { useEffect } from "react";
import { gtmEvent } from "../utils/gtmEvents";
/**
 * Fire GTM data layer event hook
 */
export const useGTMDataLayer = ({ language, pageType }) => {
    useEffect(() => {
        gtmEvent({
            pageType,
            locale: language,
            event: 'e_dataLayerReady',
        });
    }, []);
};
